<template></template>
<script>
    import PreviewTopbarSection from "./PreviewTopbarSection";
    import SchoolTopbarSection from '../../../components/pagesbuilder/sections/SchoolTopbarSection.vue';

    export default {
        name: "PreviewGlobalTopbarSection",
        mixins: [PreviewTopbarSection, SchoolTopbarSection],
        data() {
            return {}
        },
        methods: {
           
        }
        
    }
</script>
